import React from 'react';
import classNames from 'classnames';
import { InfoIcon, Text } from '@/design-system';

export interface InfoLabelProps {
  className?: string;
  label: string;
  infoText?: string;
}

export const InfoLabel: React.FC<InfoLabelProps> = ({ className, label, infoText }) => {
  const containerClasses = classNames('relative group/info-label', className);
  return (
    <div className={containerClasses}>
      <div className="flex items-center gap-2 cursor-pointer">
        <Text size="s" weight="semibold">
          {label}
        </Text>
        <div>
          <InfoIcon className="text-ds-icon-4 w-4" />
        </div>
      </div>
      <div
        className={
          'p-3 gap-3 hidden rounded-xl bg-ds-bg-surface-soft-2 info-label-max-width absolute z-3 bottom-0 left-[calc(100%+28px)]  group-hover/info-label:flex shadow-ds-elevation-neutral-l'
        }
      >
        <div>
          <InfoIcon className="text-ds-icon-4 w-6" />
        </div>
        <div className="text-ds-text-3">{infoText}</div>
      </div>
    </div>
  );
};
